import { render, staticRenderFns } from "./OrderSubmissionCustomerAddress.vue?vue&type=template&id=143973de&scoped=true&"
import script from "./OrderSubmissionCustomerAddress.vue?vue&type=script&lang=ts&"
export * from "./OrderSubmissionCustomerAddress.vue?vue&type=script&lang=ts&"
import style0 from "./OrderSubmissionCustomerAddress.vue?vue&type=style&index=0&id=143973de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143973de",
  null
  
)

export default component.exports